module.exports = __webpack_public_path__ + "img/p2.fd563d88.jpeg";